<template>
    <div class="body">
        <div class="top flex">
            <div class="title-text">进仓通知书</div>
        </div>

        <div class="section-content margin_bottom_10">
            <span>TO：</span>
            <span>尊敬的客户</span>
        </div>

        <div class="section-content margin_bottom_10">
            <div class="flex between">
                <div style="width:33%;padding-right: 20px;">贵公司委托我公司出运到 {{ PDFDataMsg.unload_port_name_en }}</div>
                <div style="width:33%;padding-right: 20px;"></div>
                <div style="width:33%;padding-right: 20px;">进仓编号：{{ PDFDataMsg.warehouse_no }}</div>
            </div>
        </div>

        <div class="section-content margin_bottom_10">
            <div class="flex between">
                <div style="width:33%;padding-right: 20px;">离港日期：{{ PDFDataMsg.etd | secondFormat("LLL") }}</div>
                <div style="width:33%;padding-right: 20px;">危险品等级：{{ PDFDataMsg.dangerous_class }}</div>
                <div style="width:33%;padding-right: 20px;">联合国编码：{{ PDFDataMsg.un_no }}</div>
            </div>
        </div>

        <div class="section-content margin_bottom_10">
            <div class="flex between">
                <div style="width:33%;padding-right: 20px;">件数：{{ PDFDataMsg.quantity }}{{ PDFDataMsg.packing_name_en }}</div>
                <div style="width:33%;padding-right: 20px;">重量：{{ PDFDataMsg.gross_weight }} KGS</div>
                <div style="width:33%;padding-right: 20px;">体积：{{ PDFDataMsg.volume }} CBM</div>
            </div>
        </div>

        <div class="section-content margin_bottom_30">
            <div class="flex between">
                <div style="width:33%;padding-right: 20px;">资料截止时间：{{ PDFDataMsg.dod | secondFormat("LLL") }}</div>
                <div style="width:33%;padding-right: 20px;">进仓截止时间：{{ PDFDataMsg.warehouse_interior_expected_arrival_date | secondFormat("LLL") }}</div>
                <div style="width:33%;padding-right: 20px;"></div>
            </div>
        </div>

        <div class="section-title margin_bottom_20">进仓信息</div>
        <div class="section-content margin_bottom_30">
            <div class="margin_bottom_10">货物请在截止前送往以下地址：{{ PDFDataMsg.warehouse_address }}</div>
            <div class="flex">
                <span style="display: inline-block; width: 250px;">仓库名称：{{ PDFDataMsg.warehouse_name }}</span>
                <span style="display: inline-block; width: 200px;">联系人：{{ PDFDataMsg.warehouse_contacts }}</span>
                <span>电话：{{ PDFDataMsg.warehouse_telephone }}</span>
            </div>
        </div>

        <!-- <div class="section-content margin_bottom_30">
            <div class="margin_bottom_10">如有任何疑问，请与我司操作联系，方法如下：</div>
            <div>地址：上海市杨浦区荆州路168号安联大厦5楼509室</div>
            <div class="flex">
                <span style="display: inline-block; width: 250px;">操作：{{ PDFDataMsg.operator_name_zh }}</span>
                <span>电话：{{ PDFDataMsg.operator_mobile }}</span>
            </div>
        </div> -->

        <div class="special-notes">
            <div class="special-notes-title">特别注意事项（以下8条务必阅读）</div>
            <div class="notes-list">
                <div class="note-item">1. 货物唛头需列明英文品名、成分、含量，并必须与报关资料完全一致。</div>
                <div class="note-item">2. 危险品货物必须打托，同时须按相关规定张贴危险品标志、海污标签(如涉及)、联合国编码、GHS中英文标签(如涉及)。</div>
                <div class="note-item">3. 包装上必须有与危包证、船级证或钢瓶证一致的UN标记，请发货人自行核对标签，后续如货上不一致我司会默认。</div>
                <div class="note-item">4. 自打托进仓货物，长、宽、高不得超过1.2米。</div>
                <div class="note-item">5. 根据仓库要求规定，入库车一定是危险品车辆，普货车一律进不去</div>
                <div class="note-item">入库必须随车携带危险顶灯、导静电带、医药箱灭火器，进入库区必须佩带安全帽。</div>
                <div class="note-item">6. 危险品车辆需五证原件和复印件齐全：</div>
                <div class="note-item">(行驶证、驾驶证、危险品道路营运证、押运员证、危化从业人员资格证)货物中文 MSDS。</div>
                <div class="note-item">7. 如普通车运输普通化工品进仓的，请带好非危保函和中文MSDS。</div>
                <div class="note-item">8. 因仓库繁忙，货物操作指令请一次给完整，多次会被拒绝操作</div>
                <div class="note-item">货物操作时间：箱子所有要求齐全后一起操作</div>
                <div class="note-item">(司机师傅请注意：换单一定在7:00-17:00在仓库换出，超过此时间，仓库不予安排当日卸货进库)</div>
            </div>
        </div>

        <div class="section-content margin_bottom_30 warning-text">
            <div class="margin_bottom_10">以上为正规出运要求 请务必保证核实清楚</div>
            <div>确认操作指令时我司将不会刻意询问 感谢配合</div>
        </div>

        <div class="page-break-safe">
            <div class="warning-text margin_bottom_20" style="font-size: 15px !important;">
                如您出运港口是欧洲或美国，特殊加贴标签要求如下：
            </div>

            <div class="special-requirements margin_bottom_30">
            <div class="requirements-section margin_bottom_20">
                <div class="requirements-title">欧盟硬性规定：</div>
                <div class="requirements-content">
                    <div class="margin_bottom_10">HAM, ROT, ASHDOD, FEX, GENOVA, VAN, ANT, PIRAEUS</div>
                    <div class="margin_bottom_10">每件货物上必须加贴危标，UN，PSN 和中英文GHS标签，中英文品名和报关一致的含量。</div>
                    <div class="margin_bottom_10">托盘四周必须加贴UN，危标和PSN。</div>
                    <div class="margin_bottom_10">汉堡这个港口需要在托盘四周额外加贴 OVERPACK 标签。</div>
                    <div class="margin_bottom_10">以上字大于1.2公分</div>
                    <div class="margin_bottom_10">字体：TIMES</div>
                    <div class="margin_bottom_10">字号：UN 60, PSN 55</div>
                    <div class="margin_bottom_10">小危标是：10*10 (CM)</div>
                    <div>运输品名是：11*29 (CM)</div>
                </div>
            </div>

            <div class="requirements-section">
                <div class="requirements-title">美国硬性规定：</div>
                <div class="requirements-content">
                    <div class="margin_bottom_10">1. 每件货物和每托必须加贴危标和 UN</div>
                    <div class="margin_bottom_10">2. 每件货物必须加贴中英文GHS标签，中英文品名和报关一致的含量。</div>
                    <div>3. 货物上必须有 MADE IN CHINA 字样</div>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        PDFDataMsg: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {}
    }
}
</script>
<style scoped>
.text_over {
    word-wrap: break-word;
    padding-right: 20px;
}

pre,
.txt,
.item,
span .txt,
div,
.left>div {
    color: rgb(0, 0, 0);
    font-size: 12px !important;
    line-height: 18px;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-rendering: optimizeLegibility;
}

.title-text {
    font-size: 30px !important;
    font-weight: bold;
    color: rgb(0, 0, 0);
    text-align: center;
    width: 100%;
    margin: 20px 0;
}

.body {
    width: 790px;
    margin: auto;
    padding: 20px;
    letter-spacing: normal !important;
    word-spacing: normal !important;
    text-rendering: optimizeLegibility;
}

.flex {
    display: flex;
}

.around {
    justify-content: space-around;
}

.between {
    justify-content: space-between;
}

.center {
    align-items: center;
}

.item {
    padding: 10px 0;
}

.pd {
    padding: 10px 0;
}

.lable {
    display: inline-block;
    width: 170px;
}

.width33>div {
    width: 33%;
}

.width50>div {
    width: 50%;
}

.box {
    border: 1px solid #000;
}

.left {
    padding: 5px;
    border-right: 1px solid #000;
}

.right {
    padding: 5px;
}

.margin_bottom_10 {
    margin-bottom: 10px;
}

.margin_bottom_20 {
    margin-bottom: 20px;
}

.margin_bottom_30 {
    margin-bottom: 30px;
}

.margin_bottom_60 {
    margin-bottom: 60px;
}

/* 增加关键区域的上边距，避免在分页时被切割 */
.special-notes {
    margin-top: 40px;
    padding-top: 20px;
}

.special-requirements {
    padding-top: 15px;
}

.page-break-safe {
    margin-top: 60px;
    padding-top: 30px;
}

.red {
    color: red !important;
    margin-bottom: 40px;
}

.section-title {
    font-size: 14px !important;
    font-weight: bold;
    color: rgb(0, 0, 0);
    margin-top: 15px;
    margin-bottom: 10px;
}

.section-content {
    color: rgb(0, 0, 0);
    font-size: 12px !important;
    line-height: 18px;
    letter-spacing: normal !important;
    word-spacing: normal !important;
}

.warning-text,
.warning-text div {
    color: #ff0000 !important;
    font-size: 20px !important;
    font-weight: bold;
}

.special-notes {
    margin: 30px 0;
}

.special-notes-title {
    color: #ff0000 !important;
    font-size: 20px !important;
    font-weight: bold;
    margin-bottom: 15px;
}

.notes-list {
    line-height: 22px;
}

.note-item {
    margin-bottom: 10px;
    color: #ff0000 !important;
    font-size: 12px !important;
    font-weight: bold;
    letter-spacing: normal !important;
    word-spacing: normal !important;
}

.special-requirements {
    padding: 10px 0;
}

.requirements-section {
    margin-bottom: 15px;
}

.requirements-title {
    font-size: 13px !important;
    font-weight: bold;
    margin-bottom: 10px;
    color: rgb(0, 0, 0);
}

.requirements-content {
    font-size: 12px !important;
    line-height: 18px;
    color: rgb(0, 0, 0);
    letter-spacing: normal !important;
    word-spacing: normal !important;
}

/* 分页控制 - 避免文字被切割 */
.section-content,
.special-notes,
.special-requirements,
.requirements-section,
.warning-text {
    page-break-inside: avoid !important;
    -webkit-region-break-inside: avoid !important;
    break-inside: avoid !important;
    overflow: visible !important;
}

.note-item,
.requirements-content > div,
.margin_bottom_10,
.margin_bottom_20 {
    page-break-inside: avoid !important;
    -webkit-region-break-inside: avoid !important;
    break-inside: avoid !important;
}

/* 确保标题和内容不分离 */
.section-title,
.special-notes-title,
.requirements-title {
    page-break-after: avoid !important;
    -webkit-region-break-after: avoid !important;
    break-after: avoid !important;
    page-break-before: auto !important;
}

/* 注意事项列表项保持完整 */
.notes-list {
    page-break-inside: auto !important;
}

/* 顶部logo区域保持完整 */
.top {
    page-break-after: avoid !important;
}

/* 整体容器 */
.body {
    page-break-before: auto !important;
    page-break-after: auto !important;
}
</style>